
import { useEffect, useState } from "react";
import { inject, observer } from 'mobx-react';
import { Card, Button, Modal, FormLoading } from '../../components'
import { SearchIcon } from '@heroicons/react/outline'
import { Input as InputAntd } from 'antd';
import { Input, DatePicker, Select, ModalAlert } from "../../components";
import { CheckIcon } from "@heroicons/react/solid";
import DataGrid, { Column } from 'devextreme-react/data-grid';
import './style.css'
import JobPlan from "./JobPlan";
import { CommonService, QueueService, RouteService } from "../../services";
import moment from 'moment';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

let firstRender = false
const { TextArea } = InputAntd;
let images = [
  {
    id: "1",
    image: "https://tailwindui.com/img/ecommerce-images/category-page-04-image-card-02.jpg",
    file_name: "ภาพถ่ายรับสินค้า",
    time: "02/03/2023 10:10",
    latlng: "17.02324, 100.9023"
  },
  {
    id: "2",
    image: "https://tailwindui.com/img/ecommerce-images/category-page-04-image-card-03.jpg",
    file_name: "ภาพถ่ายสินค้า",
    time: "02/03/2023 10:12",
    latlng: "17.02362, 100.9020"
  }
]

let imagesSignature = [
  {
    id: "1",
    image: "/Images/pic-signature.png",
    file_name: "ลายเซ็น",
    time: "02/03/2023 10:16",
    latlng: "17.02324, 100.9023",
  }
]

// const Plan = (props) => {
const Plan = inject("routeStore", "authenStore")(observer((props) => {
  const { t } = useTranslation(['plan', 'common'])
  let routeStore = props.routeStore
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  let { setRouteStore } = routeStore // ACTIONS

  const [loading, setLoading] = useState({ visible: false, tip: "กำลังโหลด" })
  const [dataQueue, setDataQueue]: any = useState([])
  const [dataRoute, setDataRoute]: any = useState([])
  const [dataDash, setDataDash]: any = useState({
    all: 0,
    open: 0,
    plan: 0,
    confirm: 0
  })
  const [queueSelected, setQueueSelected]: any = useState([])
  const [routeSelected, setRouteSelected]: any = useState([])
  const [modalInfo, setModalInfo]: any = useState({
    open: false,
    title: "",
    name: "",
    icon: ''
  })
  const [filter, setFilter]: any = useState({
    delivery_date: moment().format("YYYY-MM-DD"),
    loc_receipt_id: "",
    shipto_id: "",
    qno: "",
    doc_no: "",
    job_type_id: "",
    route_id: "",
    vid: "",
    service_id: "",
    cust_id: "",
    queue_status_id: "",
    route_status_id: ""
  })

  const [filterQueueCurrent, setFilterQueueCurrent]: any = useState({})
  const [filterRouteCurrent, setFilterRouteCurrent]: any = useState({})

  const [queueDateCurrent, setQueueDateCurrent]: any = useState("")
  const [routeDateCurrent, setRouteDateCurrent]: any = useState("")
  const [optionAlert, setOptionAlert]: any = useState({
    show: false,
    action: {
      id: "",
      name: ""
    },
    type: "success",
    title: "",
    description: {
      visible: false,
      type: "",
      content: "",
      contentLists: [],

    }
  })

  const stats = [
    { name: 'all', stat: dataDash.all },
    { name: 'open_job', stat: dataDash.open },
    { name: 'planning', stat: dataDash.plan },
    { name: 'confirm', stat: dataDash.confirm }
  ]

  let columns: any = [
    {
      dataField: 'image',
      caption: "ภาพถ่าย",
      alignment: "center",
      render: (e) => {
        return <div className="flex justify-center">
          <img
            src={e.value}
            className="w-36 h-36 mt-0.5 cursor-pointer"
          />
        </div>
      }
    },
    {
      dataField: 'file_name',
      caption: "ชื่อไฟล์ภาพ",
      alignment: "center"
    },
    {
      dataField: 'time',
      caption: "เวลา",
      alignment: "center"
    },
    {
      dataField: 'latlng',
      caption: "พิกัด",
      alignment: "center"
    }
  ]

  const [masterOptions, setMasterOptions] = useState({
    customer: [],
    shipto: [],
    service: [],
    vehicle: [],
    shipping_point: [],
    route_status: [],
    queue_status: []
  })

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      setRouteStore({ defaultDeliveryDate: filter?.delivery_date })
      CommonService.getMasterData(auth, "service,customer,shipto,vehicle,shipping_point,route_status,queue_status")
        .then((res: any) => {
          let customer = res.result.customer.map((item) => ({ label: item.cust_name, value: item.cust_id }))
          let shipto = res.result.shipto.map((item) => ({ label: item.shipto_name, value: item.shipto_id }))
          let service = res.result.service.map((item) => ({ label: item.service_name, value: item.service_id }))
          let vehicle = res.result.vehicle.map((item) => ({ label: item.licenseplate, value: item.vehicle_id }))
          let shipping_point = res.result.shipping_point.map((item) => ({ label: item.shipping_name, value: item.shipping_id }))
          let route_status = res.result.route_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          let queue_status = res.result.queue_status.map((item) => ({ label: item.status_name, value: item.status_id }))

          setMasterOptions({
            ...masterOptions,
            customer,
            shipto,
            service,
            vehicle,
            shipping_point,
            route_status,
            queue_status
          })
        })
        .catch((err) => {

        })
    }
    else
      firstRender = true
  }, [getAccountAuth])


  //#region QUEUE MANAMENT
  const searchQueue = (date = "", isReloadCurrent = false) => {
    setLoading({ ...loading, visible: true, tip: 'loading' })
    let delivery_date = date === "" ? filter.delivery_date : date
    setQueueDateCurrent(delivery_date)

    let body: any = {}
    if (isReloadCurrent) {
      body = filterQueueCurrent
    }
    else {
      body = {
        delivery_date,
        loc_receipt_id: filter.loc_receipt_id,
        shipto_id: filter.shipto_id,
        qno: filter.qno,
        job_type_id: filter.job_type_id,
        route_id: filter.route_id,
        cust_id: filter.cust_id,
        status: filter.queue_status_id,
      }
    }

    setFilterQueueCurrent(body)
    RouteService.getQueue(auth, body)
      .then((res: any) => {
        let { code, message, sys_message, result } = res
        if (code === 200) {
          setDataQueue(result)
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
        setLoading({ ...loading, visible: false, tip: 'loading' })
      })
      .catch((err) => {
        setLoading({ ...loading, visible: false, tip: 'loading' })
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
      })
  }
  const deleteQueue = (qSelected) => {
    let qids = ""
    if (qSelected.length > 0) qids = qSelected.join(',')

    QueueService.deleteQueue(auth, qids)
      .then((res: any) => {
        let { code, message, sys_message } = res
        if (code === 200) {
          setOptionAlert({
            ...optionAlert,
            type: "success",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: t('common:delete_success'),
            description: { visible: false, type: "text", content: " ", contentLists: [] }
          })
          searchQueue("", true)
          getDash()
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
      })
      .catch((err) => {
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
      })
  }
  //#endregion

  //#region ROUTE MANAGEMENT
  const searchRoute = (date = "", isReloadCurrent = false) => {
    setLoading({ ...loading, visible: true, tip: 'loading' })
    let delivery_date = date === "" ? filter.delivery_date : date
    setRouteDateCurrent(delivery_date)

    let body: any = {}
    if (isReloadCurrent) {
      body = filterRouteCurrent
    }
    else {
      body = {
        delivery_date,
        loc_receipt_id: filter.loc_receipt_id,
        shipto_id: filter.shipto_id,
        qno: filter.qno,
        doc_no: filter.doc_no,
        job_type_id: filter.job_type_id,
        route_id: filter.route_id,
        cust_id: filter.cust_id,
        service_id: filter.service_id,
        vid: filter.vid,
        status: filter.route_status_id
      }
    }

    setFilterRouteCurrent(body)
    RouteService.getRoute(auth, body)
      .then((res: any) => {
        let { code, message, sys_message, result } = res
        if (code === 200) {
          setDataRoute(result)
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
        setLoading({ ...loading, visible: false, tip: 'loading' })
      })
      .catch((err) => {
        setLoading({ ...loading, visible: false, tip: 'loading' })
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
      })
  }

  const confirmRoute = (qSelected) => {
    let route_ids = ""
    if (qSelected.length > 0) route_ids = qSelected.join(',')

    RouteService.confirmRoute(auth, route_ids)
      .then((res: any) => {
        let { code, message, sys_message } = res
        if (code === 200) {
          setOptionAlert({
            ...optionAlert,
            type: "success",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ยืนยันแผนงานสำเร็จ",
            description: { visible: false, type: "text", content: " ", contentLists: [] }
          })
          searchRoute()
          getDash()
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ยืนยันแผนงานไม่สำเร็จ",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
        // initialData()
      })
      .catch((err) => {
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ยืนยันแผนงานไม่สำเร็จ",
          description: { visible: true, type: "text", content: `${err}` }
        })
      })
  }
  const deleteRoute = (qSelected) => {
    let route_ids = ""
    if (qSelected.length > 0) route_ids = qSelected.join(',')

    RouteService.deleteRoute(auth, route_ids)
      .then((res: any) => {
        let { code, message, sys_message } = res
        if (code === 200) {
          setOptionAlert({
            ...optionAlert,
            type: "success",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: t('common:delete_success'),
            description: { visible: false, type: "text", content: " ", contentLists: [] }
          })
          searchRoute("", true)
          getDash()
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
      })
      .catch((err) => {

      })
  }

  const getDash = () => {
    RouteService.getDash(auth, filter.delivery_date)
      .then((res: any) => {
        let { code, result } = res
        if (code === 200) {
          setDataDash(result)
        }
        else {
          setDataDash({
            all: 0,
            open: 0,
            plan: 0,
            confirm: 0
          })
        }
        setLoading({ ...loading, visible: false, tip: 'loading' })
      })
      .catch((err) => {
        setLoading({ ...loading, visible: false, tip: 'loading' })
        setDataDash({
          all: 0,
          open: 0,
          plan: 0,
          confirm: 0
        })
      })
  }
  //#endregion

  const reloadData = () => {
    setLoading({ ...loading, visible: true, tip: 'loading' })
    searchQueue()
    searchRoute()
    getDash()
  }

  return (
    <div className="space-y-3 p-3">
      <Card title={t('planing_management')}>
        <div className="bg-white -my-3 p-2">
          {/* ===== ROW 1 ===== */}
          <div className="flex flex-col lg:flex-row gap-2">

            {/* DELIVERY DATE */}
            <div className="flex-1 lg:grid lg:grid-cols-3 lg:items-end lg:gap-2">
              <label className="block text-xs font-medium text-gray-700 lg:text-right">
                {t('delivery_date')} :
              </label>
              <div className="mt-1 lg:col-span-2">
                <DatePicker
                  allowClear={false}
                  placeholder={t('delivery_date')}
                  defaultValue={filter.delivery_date}
                  onChange={(d) => {
                    if (d) {
                      setFilter({ ...filter, delivery_date: d.format("YYYY-MM-DD") })
                      setRouteStore({ defaultDeliveryDate: d.format("YYYY-MM-DD") })
                    }
                    else {
                      setFilter({ ...filter, delivery_date: "" })
                      setRouteStore({ defaultDeliveryDate: "" })
                    }
                  }}
                />
              </div>
            </div>

            {/* JOB NUMBER */}
            <div className="flex-1 lg:grid lg:grid-cols-3 lg:items-end lg:gap-2">
              <label className="block text-xs font-medium text-gray-700 lg:text-right">
                {t('job_number')} :
              </label>
              <div className="mt-1 lg:col-span-2">
                <Input
                  hiddenLabel
                  placeholder={t('job_number')}
                  onChange={(e) => setFilter({ ...filter, qno: e.target.value })}
                />
              </div>
            </div>

            {/* PLAN NUMBER */}
            <div className="flex-1 lg:grid lg:grid-cols-3 lg:items-end lg:gap-2">
              <label className="block text-xs font-medium text-gray-700 lg:text-right">
                {t('plan_number')} :
              </label>
              <div className="mt-1 lg:col-span-2">
                <Input
                  hiddenLabel
                  placeholder={t('plan_number')}
                  onChange={(e) => setFilter({ ...filter, doc_no: e.target.value })}
                />
              </div>
            </div>

            {/* ORIGIN */}
            <div className="flex-1 lg:grid lg:grid-cols-3 lg:items-end lg:gap-2">
              <label className="block text-xs font-medium text-gray-700 lg:text-right">
                {t('origin')} :
              </label>
              <div className="mt-1 lg:col-span-2">
                <Select
                  showSearch={true}
                  allowClear={true}
                  hiddenLabel={true}
                  defaultValue={filter.loc_receipt_id}
                  placeholder={t('origin')}
                  options={masterOptions.shipping_point}
                  onChange={(value) => setFilter({ ...filter, loc_receipt_id: value })}
                />
              </div>
            </div>

          </div>

          {/* ===== ROW 2 ===== */}
          <div className="flex flex-col lg:flex-row gap-2">

            {/* DESTINATION */}
            <div className="flex-1 lg:grid lg:grid-cols-3 lg:items-end lg:gap-2">
              <label className="block text-xs font-medium text-gray-700 lg:text-right">
                {t('destination')} :
              </label>
              <div className="mt-1 lg:col-span-2">
                <Select
                  showSearch={true}
                  allowClear={true}
                  hiddenLabel={true}
                  defaultValue={filter.shipto_id}
                  placeholder={t('destination')}
                  options={masterOptions.shipto}
                  onChange={(value) => setFilter({ ...filter, shipto_id: value })}
                />
              </div>
            </div>

            {/* LICENSE */}
            <div className="flex-1 lg:grid lg:grid-cols-3 lg:items-end lg:gap-2">
              <label className="block text-xs font-medium text-gray-700 lg:text-right">
                {t('license_plate')} :
              </label>
              <div className="mt-1 lg:col-span-2">
                <Select
                  showSearch={true}
                  allowClear={true}
                  hiddenLabel={true}
                  defaultValue={filter.vid}
                  placeholder={t('license_plate')}
                  options={masterOptions.vehicle}
                  onChange={(value) => setFilter({ ...filter, vid: value })}
                />
              </div>
            </div>

            {/* EMPLOYEE */}
            <div className="flex-1 lg:grid lg:grid-cols-3 lg:items-end lg:gap-2">
              <label className="block text-xs font-medium text-gray-700 lg:text-right">
                {t('employee')} :
              </label>
              <div className="mt-1 lg:col-span-2">
                <Select
                  showSearch={true}
                  allowClear={true}
                  hiddenLabel={true}
                  defaultValue={filter.service_id}
                  placeholder={t('employee')}
                  options={masterOptions.service}
                  onChange={(value) => setFilter({ ...filter, service_id: value })}
                />
              </div>
            </div>

            {/* CUSTOMER */}
            <div className="flex-1 lg:grid lg:grid-cols-3 lg:items-end lg:gap-2">
              <label className="block text-xs font-medium text-gray-700 lg:text-right">
                {t('customer')} :
              </label>
              <div className="mt-1 lg:col-span-2">
                <Select
                  showSearch={true}
                  allowClear={true}
                  hiddenLabel={true}
                  defaultValue={filter.cust_id}
                  placeholder={t('customer')}
                  options={masterOptions.customer}
                  onChange={(value) => setFilter({ ...filter, cust_id: value })}
                />
              </div>
            </div>

          </div>

          {/* ===== ROW 3 + BUTTON ===== */}
          <div className="flex flex-col lg:flex-row gap-2">

            {/* JOB STATUS */}
            <div className="flex-1 lg:grid lg:grid-cols-3 lg:items-end lg:gap-2">
              <label className="block text-xs font-medium text-gray-700 lg:text-right">
                {t('job_status')} :
              </label>
              <div className="mt-1 lg:col-span-2">
                <Select
                  allowClear={true}
                  hiddenLabel={true}
                  defaultValue={filter.queue_status_id}
                  placeholder={t('job_status')}
                  options={masterOptions.queue_status}
                  onChange={(value) => setFilter({ ...filter, queue_status_id: value })}
                />
              </div>
            </div>

            {/* PLAN STATUS */}
            <div className="flex-1 lg:grid lg:grid-cols-3 lg:items-end lg:gap-2">
              <label className="block text-xs font-medium text-gray-700 lg:text-right">
                {t('plan_status')} :
              </label>
              <div className="mt-1 lg:col-span-2">
                <Select
                  allowClear={true}
                  hiddenLabel={true}
                  defaultValue={filter.route_status_id}
                  placeholder={t('plan_status')}
                  options={masterOptions.route_status}
                  onChange={(value) => setFilter({ ...filter, route_status_id: value })}
                />
              </div>
            </div>

            {/* BUTTON ZONE (ใช้ onClick เดิมทั้งหมด) */}
            <div className="flex-1 lg:grid lg:grid-cols-3 lg:items-end lg:gap-2">
              <label className="block text-xs font-medium text-gray-700 mb-1 text-right">
              </label>
              <div className="flex flex-wrap gap-2 mt-1 lg:col-span-2">
                <button
                  type="button"
                  title="ค้นหา"
                  className={`flex flex-row ${loading.visible && 'cursor-not-allowed'} items-center rounded border border-transparent bg-blue-100 mt-0.5 px-2.5 py-1.5 text-xs font-medium text-blue-700 hover:bg-blue-200`}
                  onClick={() => {
                    if (filter.delivery_date === "") {
                      setOptionAlert({
                        ...optionAlert,
                        action: { id: "", name: "" },
                        type: "info",
                        title: "โปรดระบุวันที่จัดส่ง",
                        show: true,
                        description: {
                          visible: false,
                          type: "text",
                          content: "",
                          contentLists: []
                        }
                      })
                    }
                    else {
                      reloadData()
                    }
                  }}
                >
                  <div className="flex flex-row-reverse">
                    <span>{t('search')}</span>
                    <SearchIcon className="w-4 h-4 mr-1" />
                  </div>
                </button>

                <button
                  type="button"
                  title={t('confirm_plan')}
                  className="flex flex-row items-center rounded border border-transparent bg-success-100 mt-0.5 px-2.5 py-1.5 text-xs font-medium text-success-700 hover:bg-success-200"
                  onClick={() => {
                    if (routeSelected.length === 0) {
                      setOptionAlert({
                        ...optionAlert,
                        action: { id: "", name: "" },
                        type: "info",
                        title: "โปรดเลือกแผนงาน",
                        show: true,
                        description: {
                          visible: false,
                          type: "text",
                          content: "",
                          contentLists: []
                        }
                      })
                    }
                    else {
                      setOptionAlert({
                        ...optionAlert,
                        action: { id: "", name: 'confirm-route' },
                        type: "confirm",
                        title: "ยืนยัน",
                        show: true,
                        description: {
                          visible: true,
                          type: "text",
                          content: "คุณแน่ใจที่จะยืนยันแผนงาน ?",
                          contentLists: []
                        }
                      })
                    }
                  }}
                >
                  <div className="flex flex-row-reverse">
                    <span>{t('confirm_plan')}</span>
                    <CheckIcon className="w-4 h-4 mr-1" />
                  </div>
                </button>

              </div>
            </div>
            <div className="flex-1 sm:grid sm:grid-cols-3 sm:items-end sm:gap-2" />
          </div>
        </div>
      </Card>


      <div className="bg-white rounded-md p-1 space-y-2">
        <FormLoading loading={loading.visible} tip={loading.tip}>
          <JobPlan
            auth={auth}
            filter={filter}
            queueDateCurrent={queueDateCurrent}
            dataQueue={dataQueue}
            dataRoute={dataRoute}
            setQueueSelected={(select) => setQueueSelected(select)}
            setRouteSelected={(select) => setRouteSelected(select)}
            onReloadQueue={(delivery_date) => searchQueue(delivery_date)}
            onReloadQueueCurrent={() => searchRoute("", true)}
            onReloadData={(reloadQueue) => {
              if (filter.delivery_date !== "") {
                if (reloadQueue)
                  searchQueue()
                else
                  reloadData()
              }
            }}
            onDeleteQueue={() => {
              if (queueSelected.length === 0) {
                setOptionAlert({
                  ...optionAlert,
                  action: {
                    id: "",
                    name: ""
                  },
                  type: "info",
                  title: "โปรดเลือกคิวที่ต้องการลบ",
                  show: true,
                  description: {
                    visible: false,
                    type: "text",
                    content: "",
                    contentLists: []
                  }
                })
              }
              else {
                setOptionAlert({
                  ...optionAlert,
                  action: {
                    id: "",
                    name: 'deleteQueue'
                  },
                  type: "confirm",
                  title: t('common:confirm'),
                  show: true,
                  description: {
                    visible: true,
                    type: "text",
                    content: t('common:confirm_delete_data'),
                    contentLists: []
                  }
                })
              }
            }}
            onDeleteRoute={() => {
              if (routeSelected.length === 0) {
                setOptionAlert({
                  ...optionAlert,
                  action: {
                    id: "",
                    name: ""
                  },
                  type: "info",
                  title: "โปรดเลือกแผนงานที่ต้องการลบ",
                  show: true,
                  description: {
                    visible: false,
                    type: "text",
                    content: "",
                    contentLists: []
                  }
                })
              }
              else {
                setOptionAlert({
                  ...optionAlert,
                  action: {
                    id: "",
                    name: 'deleteRoute'
                  },
                  type: "confirm",
                  title: t('common:confirm'),

                  show: true,
                  description: {
                    visible: true,
                    type: "text",
                    content: t('common:confirm_delete_data'),
                    contentLists: []
                  }
                })
              }
            }}
          />
        </FormLoading>
      </div>
      <ModalAlert
        {...optionAlert}
        onOk={async () => {
          let { action } = optionAlert

          if (action.name === "deleteQueue")
            deleteQueue(queueSelected)
          else if (action.name === "deleteRoute")
            deleteRoute(routeSelected)
          else if (action.name === "confirm-route")
            confirmRoute(routeSelected)

          setOptionAlert({ ...optionAlert, show: false })
        }}
        onCancel={() => {
          setOptionAlert({ ...optionAlert, show: false })
        }}
      />
    </div>
  )
}))

export default Plan